import React, { Component } from 'react';
import { Loader, Segment, Container } from 'semantic-ui-react';
import {
  connect
} from 'react-redux';
import ConnectServices from '../providers/ConnectServices';
import authenticate from '../authenticate';

const Authorize = (ComponentToWrap, roles = [], handleAuthentication = false) => {

  class AuthorizeComponent extends Component {

    constructor (props) {
      super(props);
      this.FeathersService = this.props.services.feathers;
      this.authenticate = authenticate(this.FeathersService, props.dispatch);
    }

    static mapDispatchToProps (dispatch) {
      return {
        dispatch
      };
    }

    static mapStateToProps (state) {
      return {
        authentication: state.authentication.toJS()
      };
    }

    componentWillMount () {
      if (handleAuthentication === true) {
        this.authenticate().catch(() => {
          // Auth bootstrap failures are handled centrally (redirect/cleanup).
        });
      }
    }

    render () {
      const auth = this.props.authentication || {};
      const user = auth.user;
      const loading = auth.loading;

      if (loading && roles.length > 0 && !user) {
        console.log('authorization requested');
        return (
          <Container>
            <Segment basic style={{marginTop: "30px", height: '50vh'}}>
              <Loader size="massive" active/>
            </Segment>
          </Container>
        );
      } else if (roles.length === 0) {
        console.log('authorization not required');
        return (
          <ComponentToWrap {...this.props} />
        );
      } else {
        console.log('roles being checked');
        const roleList = user && Array.isArray(user.roles) ? user.roles : [];
        const intersection = roleList.filter(element => roles.includes(element));
        // check roles
        if (intersection.length > 0) {
          console.log('role check passed!', ComponentToWrap);
          return (
            <ComponentToWrap {...this.props} />
          );
        } else {
          console.log('role check rejected!');
          return <div>Not Authorized</div>;
          // TODO: Make this prettier
        }
      }
    }
  };

  let connectedServices = ConnectServices(AuthorizeComponent);
  return connect(AuthorizeComponent.mapStateToProps, AuthorizeComponent.mapDispatchToProps)(connectedServices);
};

export default Authorize;



// WEBPACK FOOTER //
// ./src/components/Authorize.jsx